module.exports = __webpack_public_path__ + "static/portfolio-2-3552b16dcb2c9e8433d0781ddbc71fa5.jpg";